/* vr-announcement.js — rotates the messages of sections/vr-announcement.liquid.
   Vanilla ES6. Only loaded when the bar has two or more messages. CSS stacks every message in
   one grid cell and fades the `.is-active` one in, so swapping the class is the whole job.
   Pauses while hovered or focused, so a visitor can read and follow a link. */
(() => {
  const bars = new Map();

  const setup = (bar) => {
    const msgs = [...bar.querySelectorAll('[data-vr-announcement-msg]')];
    if (msgs.length < 2) return null;

    const delay = Math.max(2, Number(bar.dataset.interval) || 3) * 1000;
    const ac = new AbortController();
    const held = { hover: false, focus: false };
    let index = Math.max(0, msgs.findIndex((m) => m.classList.contains('is-active')));
    let timer = null;

    const show = (i) => {
      msgs[index].classList.remove('is-active');
      index = (i + msgs.length) % msgs.length;
      msgs[index].classList.add('is-active');
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const sync = () => {
      stop();
      if (!held.hover && !held.focus) timer = setInterval(() => show(index + 1), delay);
    };

    const opts = { signal: ac.signal };
    bar.addEventListener('pointerenter', () => { held.hover = true; sync(); }, opts);
    bar.addEventListener('pointerleave', () => { held.hover = false; sync(); }, opts);
    bar.addEventListener('focusin', () => { held.focus = true; sync(); }, opts);
    bar.addEventListener('focusout', (e) => {
      if (bar.contains(e.relatedTarget)) return;
      held.focus = false;
      sync();
    }, opts);

    sync();
    return { destroy: () => { stop(); ac.abort(); } };
  };

  const init = (root) => {
    (root || document).querySelectorAll('[data-vr-announcement]').forEach((bar) => {
      if (bars.has(bar)) bars.get(bar).destroy();
      const inst = setup(bar);
      if (inst) bars.set(bar, inst); else bars.delete(bar);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  /* Theme editor: the section is re-rendered on every settings change. */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-vr-announcement]').forEach((bar) => {
      if (bars.has(bar)) { bars.get(bar).destroy(); bars.delete(bar); }
    });
  });
})();
